import {
  DEVICE_TYPE,
  BROWSER_NAME,
  UA_PATTERNS,
} from "@/constants/index";

const DEFAULT_DEVICE_INFO: DeviceInfo = {
  deviceType: DEVICE_TYPE.WEB,
  deviceName: BROWSER_NAME.UNKNOWN,
};

export function getDeviceInfo(): DeviceInfo {
  // SSR guard
  if (typeof navigator === "undefined") {
    return DEFAULT_DEVICE_INFO;
  }

  const ua = navigator.userAgent;
  let deviceType: string = DEVICE_TYPE.WEB;
  let deviceName: string = BROWSER_NAME.UNKNOWN;

  // Detect OS/Platform
  if (UA_PATTERNS.ANDROID.test(ua)) {
    deviceType = DEVICE_TYPE.ANDROID;
  } else if (UA_PATTERNS.IOS.test(ua)) {
    deviceType = DEVICE_TYPE.IOS;
  } else if (UA_PATTERNS.WINDOWS.test(ua)) {
    deviceType = DEVICE_TYPE.WINDOWS;
  } else if (UA_PATTERNS.MAC.test(ua)) {
    deviceType = DEVICE_TYPE.MAC;
  } else if (UA_PATTERNS.LINUX.test(ua)) {
    deviceType = DEVICE_TYPE.LINUX;
  }

  // Detect browser
  if (UA_PATTERNS.CHROME.test(ua) && !UA_PATTERNS.EDGE.test(ua)) {
    deviceName = BROWSER_NAME.CHROME;
  } else if (UA_PATTERNS.FIREFOX.test(ua)) {
    deviceName = BROWSER_NAME.FIREFOX;
  } else if (UA_PATTERNS.SAFARI.test(ua) && !UA_PATTERNS.CHROME.test(ua)) {
    deviceName = BROWSER_NAME.SAFARI;
  } else if (UA_PATTERNS.EDGE.test(ua)) {
    deviceName = BROWSER_NAME.EDGE;
  }

  return { deviceType, deviceName };
}
